var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 15.5C23.75 20.75 17 25.25 17 25.25C17 25.25 10.25 20.75 10.25 15.5C10.25 13.7098 10.9612 11.9929 12.227 10.727C13.4929 9.46116 15.2098 8.75 17 8.75C18.7902 8.75 20.5071 9.46116 21.773 10.727C23.0388 11.9929 23.75 13.7098 23.75 15.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.75C18.2426 17.75 19.25 16.7426 19.25 15.5C19.25 14.2574 18.2426 13.25 17 13.25C15.7574 13.25 14.75 14.2574 14.75 15.5C14.75 16.7426 15.7574 17.75 17 17.75Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventLocation);
export default __webpack_public_path__ + "static/media/event-location.b7e220bdb261707d0d7b9f3d969f7d64.svg";
export { ForwardRef as ReactComponent };